import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Button } from 'antd';
import AuthService from '../../utils/auth';

export const HasPermission = ({ anyOf = [], fallback = null, children }) =>
  AuthService.hasAnyPermission(anyOf) ? children : fallback;

export const PermissionButton = ({ permission, permissions, fallback = null, ...props }) => {
  const anyOf = permissions || (permission ? [permission] : []);
  if (!AuthService.hasAnyPermission(anyOf)) return fallback;
  return <Button {...props} />;
};

export const RequirePermission = ({ anyOf = [], children }) => {
  const location = useLocation();
  if (!AuthService.hasAnyPermission(anyOf)) {
    return <Navigate to="/403" replace state={{ from: location.pathname }} />;
  }
  return children;
};
